import type { Item } from '@/entities/item/schemas/item';
import type { ShoppingItem } from '@/entities/shopping-item/schemas/shopping-item';
import type { IsoDate } from '@/shared/lib/dates/iso-date';

/** Buying something from the list: the inventory item it becomes. */
export function itemFromPurchase(entry: ShoppingItem, boughtOn: IsoDate): Partial<Item> {
  return {
    name: entry.name,
    category: entry.category,
    quantity: entry.quantity,
    unit: entry.unit,
    price_cents: entry.price_cents ?? entry.estimated_price_cents,
    store: entry.store,
    purchased_on: boughtOn,
    notes: entry.notes,
  };
}
